import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Layout, Space, Button, message } from 'antd';
import './index.less';
import TinymceEditor from '../TinymceEditor';
import { moduleUpdateApi, moduleGetByIdApi } from '@services/MedProject';
import config from '@config';
export default function ModulesDetails() {
    const navigate = useNavigate();
    const params = useParams();

    const id = params?.id || 0;
    const projectId = params?.projectId || 0;

    const [details, setDetails] = useState(null);
    const [editorContents, setEditorContents] = useState('');
    const [initEditorValue, setInitEditorValue] = useState(null);

    const handleOk = async () => {
        const reqParams = {
            id: details.id,
            moduleType: details.moduleType,
            name: details.name,
            content: editorContents,
            projectId: details.projectId,
            isShowHot: details.isShowHot,
            isShowTab: details.isShowTab,
        };
        const res = await moduleUpdateApi(reqParams);
        if (res && res.status_code === 200) {
            message.success('保存成功');
        }
    };

    const getDetails = async () => {
        const res = await moduleGetByIdApi({ id });
        if (res && res.status_code === 200) {
            setDetails(res.data);
            setEditorContents(res.data.content);
            setInitEditorValue(res.data.content);
        }
    };

    useEffect(() => {
        getDetails();
    }, [id]);

    return (
        <>
            <div className="med-project-module-head">
                <div className="module-title">
                    <h2>项目详情</h2>
                    <span className="tips">编辑内容使用的一级标题‘H1’，会在用户端做为目录导航呈现。如需上传图片，建议图片宽度保持1700 px，图片两侧不建议留白。</span>
                </div>
                <div className="preview">
                    <Button
                        type="link"
                        size="small"
                        style={{ padding: 0 }}
                        onClick={() => window.open(`${config.PROJECT_DOMAIN}/p/${projectId}/info/${details.id}`)}
                        icon={
                            <>
                                <span className="anticon">
                                    <i className="bi bi-box-arrow-up-right"></i>
                                </span>
                            </>
                        }
                    >
                        <span>预览</span>
                    </Button>
                </div>
            </div>

            <Space className="main-details">
                <TinymceEditor initEditorValue={initEditorValue} setEditorContents={setEditorContents} editorContents={editorContents} id="editorContents" placeholder="编辑内容使用的一级标题‘H1’，会在用户端做为目录导航呈现。如需上传图片，建议图片宽度保持1700px，图片两侧不建议留白。" />
            </Space>

            <div className="main-footer">
                <Button type="primary" onClick={() => handleOk()}>
                    保存
                </Button>
            </div>
        </>
    );
}
